import { CommonModule } from '@angular/common';
import { Component, inject, input, Input, OnInit, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { DatetimeCustomEvent } from '@ionic/angular';
import { endOfDay, parse, startOfDay } from 'date-fns';
import { Observable } from 'rxjs';
import { filter, map, shareReplay, startWith } from 'rxjs/operators';
import { AppCommonModule } from 'src/app/common.module';
import { UserSessionService } from 'src/app/services/user-session.service';
import { selectedDayFormat } from 'src/app/utility/time';

@Component({
  selector: 'app-selected-day',
  templateUrl: './selected-day.component.html',
  styleUrls: ['./selected-day.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    AppCommonModule,
  ],
})
export class SelectedDayComponent implements OnInit {
  private usersService = inject(UserSessionService);

  currentDayISO: string;

  id = input.required<string>();

  @Input()
  set currentDay(value: string) {
    if (value) {
      const date = parse(value, selectedDayFormat, new Date());
      this.currentDayISO = endOfDay(date).toISOString();
    }
  }

  changed = output<Date>();

  willEnter = signal(false);

  locale$: Observable<string> = this.usersService.getCurrentUser().pipe(
    filter((user) => user != null),
    map((user) => user.lang ?? 'fi'),
    startWith('fi'),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  ngOnInit(): void {
    this.willEnter.set(true);
  }

  onDayChange(event: DatetimeCustomEvent) {
    const value = event.detail.value as string;
    if (value !== this.currentDayISO) {
      const date = new Date(value);
      this.changed.emit(startOfDay(date));
    }
  }

}
